import axios from "./axios-auth";

const getPrograms = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getprograms",
      data: params,
      method: "POST",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const getAuthorizedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getauthorizedclients",
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while fetching authorized clients api");
      });
  });

const getClientsByProgrammeId = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientsbyprogramid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getClientsByProgrammeId api");
      });
  });

const getUsers = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getusers",
      data: params,
      method: "POST",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const updateUsersPoints = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updateuserspoints",
      data: params,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const getProgramDetailsById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getprogramdetails",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "error from getProgramDetailsById api");
      });
  });

export {
  getPrograms,
  getAuthorizedClients,
  getUsers,
  updateUsersPoints,
  getClientsByProgrammeId,
  getProgramDetailsById,
};
